export default "__VITE_ASSET__BbWq6sRp__"